import { styled, spacing, mq, Text, css } from '@thg-commerce/enterprise-theme'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { Image } from './elements'

export const WidgetGridItem = styled(GridItem)`
  margin-top: ${spacing(7)};
  margin-bottom: ${spacing(7)};
`

export const RecipeGridItem = styled(GridItem)`
  margin-bottom: ${spacing(3)};
`

export const ElementGridItem = styled(GridItem)`
  margin-bottom: 0;

  p {
    margin: 0 0 ${spacing(2)};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: ${spacing(7)} 0 ${spacing(2)};
  }

  h1,
  h1 a {
    ${Text('xlarge1', 'alternate')}
  }

  h2,
  h2 a {
    ${Text('large2', 'alternate')}
  }

  h3,
  h3 a {
    ${Text('large1', 'alternate')}
  }

  h4,
  h4 a {
    ${Text('medium1', 'alternate')}
  }

  h5,
  h5 a,
  h6,
  h6 a {
    ${Text('bodyText', 'alternate')}
  }

  img {
    width: 100%;
    height: auto;
  }

  strong {
    ${Text('bodyText', 'alternate')}
    font-size: inherit;
    font-style: inherit;

    ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
      font-size: inherit;
      font-style: inherit;
    }
  }

  em {
    font-style: italic;
    font-size: inherit;
    font-weight: inherit;
  }

  ol {
    counter-reset: item;

    li {
      display: block;

      &:before {
        content: counter(item) '. ';
        counter-increment: item;
        width: 2em;
        display: inline-block;
      }
    }
  }

  ul {
    list-style: disc;
    margin-bottom: ${spacing(2)};
    margin-left: calc(${spacing(2)} + 2px);
  }

  table {
    display: block;
    margin-top: ${spacing(7)};
    width: 100%;
    overflow-x: auto;

    thead {
      ${Text('bodyText', 'alternate')}
    }

    tr {
      background-color: ${(props) => props.theme.colors.palette.greys.white};
    }

    tr:nth-child(even) {
      background-color: ${(props) => props.theme.colors.palette.greys.lighter};
    }

    td {
      padding: ${spacing(1)};
      border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
    }
  }

  hr {
    margin: ${spacing(2)} 0;
    border: none;
    border-bottom: 1px solid
      ${(props) => props.theme.colors.palette.greys.light};
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    + div:first-of-type {
      margin-top: ${spacing(3)};

      table {
        margin-top: 0;
      }
    }
  }

  ul + div:first-of-type {
    margin-top: ${spacing(7)};
  }

  blockquote {
    ${Text('large2', 'alternate')};
    display: inline-block;
    text-align: center;
    quotes: '“' '”' '‘' '’';

    &::before {
      content: open-quote;
    }

    &::after {
      content: close-quote;
    }

    &::before,
    &::after {
      ${Text('xlarge2', 'alternate')};
      color: ${(props) => props.theme.colors.palette.accent.base};
    }

    * {
      ${Text('large2', 'alternate')};
      text-align: center;
    }
  }

  sup {
    ${Text('xsmall', 'default')};
    position: relative;
    top: -0.5em;
  }

  sub {
    ${Text('xsmall', 'default')};
    position: relative;
    bottom: -0.25em;
  }
`

export const StyledGrid = styled(Grid)`
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;

  ${ElementGridItem}:first-of-type > *:first-child:not(table) {
    margin-top: 0;
  }

  ${ElementGridItem}:last-of-type > *:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`
export const StyledImage = styled(Image)<{
  imageAlignment?: 'left' | 'center' | 'right'
}>`
  max-width: 100%;
  height: auto;
  img {
    margin: 0;
  }

  ${(props) => {
    const spacingValue = spacing(2)
    switch (props.imageAlignment) {
      case 'left':
        return css`
          float: left;
          margin: 0 ${spacingValue} ${spacingValue} 0;
        `
      case 'center':
        return css`
          margin: 0 auto ${spacingValue};
          display: block;
        `
      case 'right':
        return css`
          float: right;
          margin: 0 ${spacingValue};
        `
      default:
        return null
    }
  }}
`
